var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_sms-edit",
    "data-name": "vuesax/linear/sms-edit",
    transform: "translate(0 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-edit",
    transform: "translate(0 250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.917,21.958H6.458C2.583,21.958,0,20.021,0,15.5V6.458C0,1.938,2.583,0,6.458,0H19.375c3.875,0,6.458,1.938,6.458,6.458v3.875",
    transform: "translate(2.583 4.521)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.917,0,8.874,3.229a4.089,4.089,0,0,1-4.844,0L0,0",
    transform: "translate(9.042 11.625)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.596 18.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.217.74.645,5.313a1.592,1.592,0,0,0-.388.762L.012,7.818A.82.82,0,0,0,.993,8.8l1.744-.245A1.536,1.536,0,0,0,3.5,8.167L8.072,3.595a1.763,1.763,0,0,0,0-2.868A1.757,1.757,0,0,0,5.217.74Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0A4.114,4.114,0,0,0,2.868,2.868",
    transform: "translate(4.558 1.399)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H31V31H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin3);
export default __webpack_public_path__ + "static/media/spin3.2e11aeeb2d10602233f3ec448700dc9e.svg";
export { ForwardRef as ReactComponent };